import Vue from 'vue'
import VueRouter from 'vue-router'
// import App from '../App.vue'
import store from '@/store/index'
import App3D from '../App3D.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Cotizador',
    component: App3D
  },
  {
    path: '/YouReprocesos/:identificador',
    name: 'youReprocesos',
    beforeEnter(to, from, next) {

      const activeYouReprocesos = process.env.VUE_APP_ACTIVE_YOUREPROCESOS === 'true';
      if (activeYouReprocesos) {
        store.dispatch('config/setYouReprocesosSession', to.params.identificador);
      }

      next();
    },
    component: App3D
  },
  {
    path: '/',
    name: 'New Cotizador',
    component: App3D
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
